import { toggleInfoModal, toggleContactsModal } from "@shared/actions/lobby";
import { Button } from "@shared/components";
import { useLobbyParams } from "@shared/hooks/lobby/lobby";
import { useIsAuth } from "@shared/hooks/user";
import React from "react";
import { useIntl } from "react-intl";
import { useDispatch } from "react-redux";

const FooterMenu = () => {
  const intl = useIntl();
  const dispatch = useDispatch();

  const isAuth = useIsAuth();
  const { lobbyButtons } = useLobbyParams() ?? {};
  const isContactsButtonShown = lobbyButtons?.contacts?.enabled ?? false;

  const toggleModalInfoShow = () => {
    dispatch(toggleInfoModal(true));
  };

  const toggleModalContactShow = () => {
    dispatch(toggleContactsModal(true));
  };

  if (isAuth) {
    return (
      <div className="footer__menu">
        <ul className="container">
          {isContactsButtonShown && (
            <li>
              <Button tagName="button" onClick={toggleModalContactShow}>
                {intl.formatMessage({
                  id: "boilerplate.components.ModalContacts.title",
                })}
              </Button>
            </li>
          )}
          <li>
            <Button tagName="button" onClick={toggleModalInfoShow}>
              {intl.formatMessage({
                id: "boilerplate.info",
              })}
            </Button>
          </li>
        </ul>
      </div>
    );
  }
  return null;
};

export default FooterMenu;
